export default "__VITE_ASSET__BHNXniwF__"